export default "__VITE_ASSET__B3A6Fk$C__"